import { useState, useEffect } from 'react';

export default function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20Nigerian%20telecom%20service%20center%20with%20professional%20staff%20assisting%20customers%2C%20bright%20clean%20environment%20with%20blue%20and%20orange%20branding%2C%20contemporary%20retail%20space%20with%20digital%20displays%20and%20technology%20equipment%2C%20customer%20service%20excellence%2C%20professional%20business%20atmosphere%20with%20African%20context&width=1200&height=600&seq=gallery-001&orientation=landscape',
      title: 'Customer Service Excellence',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=African%20business%20professionals%20in%20training%20session%20learning%20digital%20skills%2C%20modern%20classroom%20with%20computers%20and%20technology%2C%20instructor%20teaching%20group%20of%20young%20Nigerians%2C%20collaborative%20learning%20environment%2C%20bright%20professional%20setting%20with%20educational%20technology&width=1200&height=600&seq=gallery-002&orientation=landscape',
      title: 'Skills Training Programs',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Nigerian%20tech%20startup%20office%20with%20young%20professionals%20working%20on%20fintech%20solutions%2C%20modern%20workspace%20with%20multiple%20computer%20screens%20showing%20financial%20data%2C%20collaborative%20team%20environment%2C%20contemporary%20office%20design%20with%20blue%20and%20orange%20accents%2C%20innovation%20and%20technology%20focus&width=1200&height=600&seq=gallery-003&orientation=landscape',
      title: 'Fintech Innovation',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20African%20business%20meeting%20discussing%20digital%20transformation%20strategy%2C%20modern%20conference%20room%20with%20presentation%20screens%2C%20diverse%20team%20of%20Nigerian%20professionals%20collaborating%2C%20contemporary%20corporate%20environment%2C%20technology%20and%20business%20planning%20atmosphere&width=1200&height=600&seq=gallery-004&orientation=landscape',
      title: 'Business Solutions',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Nigerian%20telecommunications%20infrastructure%20with%20modern%20network%20equipment%20and%20servers%2C%20professional%20IT%20technician%20working%20on%20digital%20systems%2C%20clean%20technical%20environment%20with%20blue%20lighting%2C%20advanced%20technology%20setup%2C%20connectivity%20and%20infrastructure%20theme&width=1200&height=600&seq=gallery-005&orientation=landscape',
      title: 'Network Infrastructure',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Happy%20Nigerian%20customers%20receiving%20excellent%20service%20at%20modern%20tech%20service%20center%2C%20friendly%20staff%20helping%20clients%20with%20digital%20services%2C%20bright%20welcoming%20environment%2C%20customer%20satisfaction%20and%20professional%20service%20delivery%2C%20contemporary%20retail%20space%20with%20technology%20focus&width=1200&height=600&seq=gallery-006&orientation=landscape',
      title: 'Customer Satisfaction',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Gallery</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            A glimpse into our operations, services, and the impact we're making across Nigeria
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {/* Main Image Container */}
          <div className="relative overflow-hidden rounded-2xl shadow-2xl h-96 md:h-[500px]">
            {images.map((image, index) => (
              <div
                key={index}
                className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                  index === currentIndex
                    ? 'opacity-100 translate-x-0'
                    : index < currentIndex
                    ? 'opacity-0 -translate-x-full'
                    : 'opacity-0 translate-x-full'
                }`}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent">
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h4 className="text-2xl md:text-3xl font-bold text-white">{image.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={goToPrevious}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all cursor-pointer z-10"
            aria-label="Previous slide"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
          </button>
          <button
            onClick={goToNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all cursor-pointer z-10"
            aria-label="Next slide"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-3 mt-8">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all cursor-pointer ${
                  index === currentIndex
                    ? 'w-12 h-3 bg-blue-600 rounded-full'
                    : 'w-3 h-3 bg-gray-300 hover:bg-gray-400 rounded-full'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}